/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { AgentHostWorktree } from "./AgentHostWorktree";
import {
  AgentHostWorktreeFromJSON,
  AgentHostWorktreeFromJSONTyped,
  AgentHostWorktreeToJSON,
  AgentHostWorktreeToJSONTyped,
} from "./AgentHostWorktree";

/**
 *
 * @export
 * @interface AgentHostWorktreesResponse
 */
export interface AgentHostWorktreesResponse {
  /**
   *
   * @type {Array<AgentHostWorktree>}
   * @memberof AgentHostWorktreesResponse
   */
  worktrees: Array<AgentHostWorktree>;
  /**
   *
   * @type {number}
   * @memberof AgentHostWorktreesResponse
   */
  totalSizeBytes: number;
  /**
   *
   * @type {number}
   * @memberof AgentHostWorktreesResponse
   */
  diskTotalBytes?: number | null;
  /**
   *
   * @type {number}
   * @memberof AgentHostWorktreesResponse
   */
  diskFreeBytes?: number | null;
}

/**
 * Check if a given object implements the AgentHostWorktreesResponse interface.
 */
export function instanceOfAgentHostWorktreesResponse(
  value: object,
): value is AgentHostWorktreesResponse {
  if (!("worktrees" in value) || value["worktrees"] === undefined) return false;
  if (!("totalSizeBytes" in value) || value["totalSizeBytes"] === undefined)
    return false;
  return true;
}

export function AgentHostWorktreesResponseFromJSON(
  json: any,
): AgentHostWorktreesResponse {
  return AgentHostWorktreesResponseFromJSONTyped(json, false);
}

export function AgentHostWorktreesResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): AgentHostWorktreesResponse {
  if (json == null) {
    return json;
  }
  return {
    worktrees: (json["worktrees"] as Array<any>).map(AgentHostWorktreeFromJSON),
    totalSizeBytes: json["totalSizeBytes"],
    diskTotalBytes:
      json["diskTotalBytes"] == null ? undefined : json["diskTotalBytes"],
    diskFreeBytes:
      json["diskFreeBytes"] == null ? undefined : json["diskFreeBytes"],
  };
}

export function AgentHostWorktreesResponseToJSON(
  json: any,
): AgentHostWorktreesResponse {
  return AgentHostWorktreesResponseToJSONTyped(json, false);
}

export function AgentHostWorktreesResponseToJSONTyped(
  value?: AgentHostWorktreesResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    worktrees: (value["worktrees"] as Array<any>).map(AgentHostWorktreeToJSON),
    totalSizeBytes: value["totalSizeBytes"],
    diskTotalBytes: value["diskTotalBytes"],
    diskFreeBytes: value["diskFreeBytes"],
  };
}
